import { defineMessage, MessageDescriptor } from 'react-intl'

import { ServiceProviderCategoryEnum } from './../../lib/graphql'

export const getServiceProviderCategoryToLabel = (
  serviceProviderCategory: ServiceProviderCategoryEnum,
): MessageDescriptor => {
  switch (serviceProviderCategory) {
    case ServiceProviderCategoryEnum.ACTIVITY:
      return defineMessage({
        id: 'serviceProvider.category.activity',
        defaultMessage: 'Activité',
      })
    case ServiceProviderCategoryEnum.RESTAURATION:
      return defineMessage({
        id: 'serviceProvider.category.restoration',
        defaultMessage: 'Restauration',
      })
    case ServiceProviderCategoryEnum.TRANSPORT:
      return defineMessage({
        id: 'serviceProvider.category.transport',
        defaultMessage: 'Transport',
      })
    case ServiceProviderCategoryEnum.HOUSE:
      return defineMessage({
        id: 'serviceProvider.category.house',
        defaultMessage: 'Lieu',
      })
    case ServiceProviderCategoryEnum.BATCH_PROVISIONS:
      return defineMessage({
        id: 'serviceProvider.category.batchProvisions',
        defaultMessage: 'Forfaits',
      })
    case ServiceProviderCategoryEnum.FEES_ADJUSTMENTS:
      return defineMessage({
        id: 'serviceProvider.category.feesAdjustments',
        defaultMessage: 'Ajustements de frais',
      })
    case ServiceProviderCategoryEnum.TAXES:
      return defineMessage({
        id: 'serviceProvider.category.taxes',
        defaultMessage: 'Taxes',
      })
    case ServiceProviderCategoryEnum.TOTAL:
      return defineMessage({
        id: 'serviceProvider.category.total',
        defaultMessage: 'Total',
      })
  }
}
